import { first, map } from 'lodash';
import { matchRoutes, type RouteMatch } from 'react-router-dom';
import { browserHistory } from '../../store/utils/history';
import {
  type Location,
  type ModalRouteLocations,
  modalRouteLocations,
  routeCreators,
} from './AppRoutes';

interface RedirectModalResult {
  background: string;
  pathname: string;
}

export const getRedirectModal = ({ pathname }: Location): RedirectModalResult | null => {
  const match = matchRoutes(
    map(modalRouteLocations, (route, key) => ({ path: route.path.pathname, id: key })),
    pathname,
  );
  const route = first(match);

  return route ? { background: getModalBackgroundLocation(route), pathname: route.pathname } : null;
};

export const redirectModal = ({ pathname, background }: RedirectModalResult) => {
  browserHistory.replace(background);
  browserHistory.push(pathname, { background });
};

function getModalBackgroundLocation(route: RouteMatch) {
  const appRouteKey = route.route.id as keyof ModalRouteLocations;

  if (appRouteKey === 'intermodalCreate' || appRouteKey === 'intermodalDetailsEdit') {
    return routeCreators.intermodal();
  }

  return routeCreators.bookings();
}
